module.exports = __webpack_public_path__ + "img/installments.f6dbf487.svg";